import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './components/Home';
import Login from './components/Login';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CopyrightPolicy from './pages/CopyrightPolicy';
import AboutUs from './pages/AboutUs';
import BalancePage from './pages/BalancePage';
import ProtectedRoute from './components/ProtectedRoute';
import { CreditProvider } from './contexts/CreditContext';

function App() {
    return (
        <Router>
            <CreditProvider>
                <Routes>
                    <Route path="/login" element={<Login/>}/>
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Home/>
                            </ProtectedRoute>
                        }
                    />
                    <Route 
                        path="/balance" 
                        element={
                            <ProtectedRoute>
                                <BalancePage/>
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/privacy" element={<PrivacyPolicy/>} />
                    <Route path="/terms" element={<TermsOfService/>} />
                    <Route path="/copyright" element={<CopyrightPolicy/>} />
                    <Route path="/about" element={<AboutUs/>} />
                </Routes>
                <Footer/>
            </CreditProvider>
        </Router>
    );
}

export default App;
